import { Hero } from "../components/landing/Hero";
// import { Quickstart } from "../components/landing/Quickstart";
import { ProductCards } from "../components/landing/ProductCards";

export const LandingPage = () => (
    <>
        <Hero className="my-12 px-6"/>
        <section className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">
                Choose Your Product
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Our suite of regulatory technology products covers every stage
                of your fintech journey, from initial testing to production
                compliance and next-generation digital currency infrastructure.
            </p>
        </section>
        <ProductCards className="my-16 px-6" />
    </>
)
